
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"2500","height":"2500","viewBox":"0 0 44.004 44.004"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2E3B4E","d":"M36.65 0H7.354A7.354 7.354 0 000 7.354V36.65a7.354 7.354 0 007.354 7.354H36.65a7.353 7.353 0 007.354-7.354V7.354A7.352 7.352 0 0036.65 0zm-.646 33.686a2.32 2.32 0 01-2.32 2.319H10.325a2.32 2.32 0 01-2.321-2.319v-23.36a2.32 2.32 0 012.321-2.321h23.358a2.32 2.32 0 012.32 2.321v23.36z"}}),_c('path',{attrs:{"fill":"#2E3B4E","d":"M17.333 28.003a1.336 1.336 0 01-1.332-1.339V17.34c0-.739.596-1.339 1.332-1.339h9.338c.738 0 1.332.6 1.332 1.339v9.324c0 .738-.594 1.339-1.332 1.339h-9.338z"}})])
          )
        }
      }
    